import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {NotificationModalComponent} from '../notfication-modal/notification-modal.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ResultsListComponent} from '@shared/results-list/results-list.component';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';
import {BaseService} from '@shared/services/base.service';
import {ToastService} from '@shared/services/toast.service';

@Component({
    selector: 'app-notification',
    imports: [CommonModule, FormsModule, ResultsListComponent, HelpDocsLinksComponent],
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  searchObj = {status: 'issued'};
  search: string;
  open = {};
  oneStopFields = ['site_name', 'gepa_ref_number', 'dpw_permit_number', 'type'];
  oneStopRowButtons = [
    {
      title: 'Notify Originals Needed',
      hideExpression: 'item.permittee_notified === null',
      func: (item) => {
        const modalInstance = this.modal.open(NotificationModalComponent, {backdrop: 'static', size: 'lg'});
        modalInstance.componentInstance.globalid = item.globalid;
        modalInstance.result.then((results) => {
          if (results === 'email') {
            this.permitService.customPOST(`${item.globalid}/notify_originals_needed`, {})
              .subscribe(() => {
                  this.toastr.success('Email sent successfully.');
                  item.permittee_notified = new Date();
                },
                () => {
                  this.toastr.error('Error sending email.');
                });
          } else {
            item.permittee_notified = new Date();
            this.save(item);
          }
        });
      }
    },
    {
      title: 'Originals Received',
      hideExpression: 'item.originals_received === null',
      func: (item) => {
        item.originals_received = new Date();
        this.save(item);
      }
    },
    {
      title: 'Notify Signed',
      hideExpression: 'item.originals_signed === null',
      func: (item) => {
        const modalInstance = this.modal.open(NotificationModalComponent, {backdrop: 'static', size: 'lg'});
        modalInstance.componentInstance.globalid = item.globalid;
        modalInstance.result.then((results) => {
          if (results === 'email') {
            this.permitService.customPOST(`${item.globalid}/notify_signed`, {})
              .subscribe(() => {
                this.toastr.success('Email sent successfully.');
                item.originals_signed = new Date();
              }, () => {
                this.toastr.error('Error sending email.');
              });
          } else {
            item.originals_signed = new Date();
            this.save(item);
          }
        });
      }
    },
    {
      title: 'Originals Picked-up',
      hideExpression: 'item.originals_picked_up === null',
      func: (item) => {
        item.originals_picked_up = new Date();
        this.save(item);
      }
    }
  ];
  rowButtons: any[] = [];
  display_fields: string[] = [];
  permitService: BaseService;

  constructor(public modal: NgbModal, public toastr: ToastService, public http: HttpClient,
              public router: Router, public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.data.subscribe((data: any) => {
      this.permitService = new BaseService(`${environment.baseUrl}/${data.type}`, this.http);

      if (data.type === 'onestop/permits') {
        this.rowButtons = this.oneStopRowButtons;
        this.display_fields = this.oneStopFields;
      }
      if (data.type === 'standbygenerator/permits') {
        this.display_fields = ['site_name', 'number', 'type'];
      }
    })
    this.route.queryParams.subscribe(params => {
      this.search = params.search;
      this.searchObj = {...this.searchObj, ...params};
    });
  }

  openCalendar(e, date) {
    this.open[date] = true;
  };

  save(item) {
    this.permitService.save(item).subscribe(
      () => {
        this.toastr.success('Saved');
      },
      () => {
        this.toastr.error('Error saving');
      });
  }

  toggleAll() {
    if (this.searchObj.status === 'issued') {
      this.searchObj.status = '';
    } else if (this.searchObj.status === '') {
      this.searchObj.status = 'issued';
    }
    // this.runSearch();
  };

  runSearch() {
    this.router.navigate([], {queryParams: {search: this.search}});
  }

}
